import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { SET_WELCOME_NEWS, SET_LOBBY_NEWS, SET_LOBBY_BACKGROUND_PROMO } from './types';
export var setWelcomeNews = function setWelcomeNews(newsData) {
  return {
    type: SET_WELCOME_NEWS,
    payload: _objectSpread({}, newsData)
  };
};
export var setLobbyNews = function setLobbyNews(newsList) {
  return {
    type: SET_LOBBY_NEWS,
    payload: newsList
  };
};
export var setLobbyBackgroundPromo = function setLobbyBackgroundPromo(background) {
  return {
    type: SET_LOBBY_BACKGROUND_PROMO,
    payload: background
  };
};